import {
  faCheck,
  faEllipsisVertical,
  faEye,
  faPencil,
  faPenToSquare,
  faRotate,
  faTrash,
  faUpload,
  faXmark,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, Row, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../../../components/helper/Date";
import EditSettingModel from "../../../../components/Modal/EditSetting.modal";
import ShiftModal from "../../../../components/Modal/Shift.model";
import ClientTable from "../../../../components/table/Client.table";
import AdminService from "../../../../services/admin.service";
import ExamService from "../../../../services/exam.service";
import ConfirmModal from "../../../../components/Modal/Confirm.modal";
import CustomToggle from "../../../../components/toggle/CustomToggle";
import EditShiftModal from "../../../../components/Modal/EditShift.modal";
import DatePicker from "react-datepicker"
import moment from 'moment'
import OperatorTable from "../../../../components/table/Operator.table";
import ReverificationDetails from "./ReverificationDetails";

const ExamById = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [exam, setExam] = useState<any>();
  const [enumsData, setEnumsData] = useState<any>();
  const [examSetting, setExamSetting] = useState<any>();
  const [showEditModal, setShowEditModal] = useState<any>(false);
  const [showShiftModal, setShowShiftModal] = useState<boolean>(false);
  const [clients, setClients] = useState<any>();
  const [operators, setOperators] = useState<any>();
  const [showDeleteShift, setShowDeleteModal] = useState<any>(undefined);
  const [showCreateClient, setShowCreateClient] = useState<boolean>(false);
  const [newClientEmail, setNewClientEmail] = useState<string>("");
  const [showCreateOperator, setShowCreteOperator] = useState<boolean>(false);
  const [newOperatorEmail, setNewOperatorEmail] = useState<string>("");
  const [newUserName, setnewUserName] = useState<string>("");
  const [collegeName, setCollegeName] = useState<string>("");
  const [collegeId, setCollegeId] = useState<string>("");
  const [stream, setStream] = useState<string>("");

  const [toggleExamOffline, setToggleExamOffline] = useState<boolean>(false);
  const [editShift, setEditShift] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [settingValue, setSettingValue] = useState<any>([]);

  const handleCheckedValue = (e: any, enum_type: string) => {
    const old_settingValue = settingValue;
    const rem_settings = old_settingValue.filter(
      (setting: any) => setting.method != enum_type
    );
    let current_enum = old_settingValue.find(
      (setting: any) => setting.method == enum_type
    );
    if (!current_enum) {
      current_enum = {
        method: enum_type,
        [e.target.name]: e.target.checked,
      };
    } else {
      current_enum = { ...current_enum, [e.target.name]: e.target.checked };
    }
    setSettingValue([...rem_settings, current_enum]);
  };

  const updateSetting = async () => {
    await AdminService.updateSettings(params.examId, settingValue)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Exam setting update successfully");
        }
        setShowEditModal(false);
        getExamSetting();
      })
      .catch((err) => {
        toast.error("Unable to update exam settings..");
      });
  };

  const getAllExamById = async () => {
    await ExamService.getAllExamById(params.examId)
      .then((res) => {
        if (res.status === 200) {
          setExam(res.data.data.exam);
          setToggleExamOffline(res.data.data.exam?.offlineMode || false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllEnums = async () => {
    await AdminService.getAllEnumsForVerification()
      .then((res) => {
        if (res.status === 200) {
          setEnumsData(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getExamSetting = async () => {
    await AdminService.getExamSetting(params.examId)
      .then((res) => {
        if (res.status === 200) {
          setExamSetting(res.data.data.settings);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function handleChangeData(e: any) {
    setData({ ...data, [e.target.name]: e.target.value })
  }

  const getAllClients = async () => {
    await AdminService.getAllClients(params.examId).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        setClients(res.data.data.client);
      }
    });
  };

  const handleCreateClient = async () => {
    // if(!newClientEmail){
    //     toast.error("Please enter client email");
    //     return;
    // }
    await AdminService.createClient(params.examId, { email: newClientEmail })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Client created successfully");
          getAllClients();
          setShowCreateClient(false);

          setNewClientEmail("");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data || "Unable to create client");
      });
  };

  const getAllOperators = async () => {
    await AdminService.getAllOperatoprs(params.examId).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        setOperators(res?.data?.data?.operators || []);
      }
    });
  };
  const handleCreateOperator = async () => {
    if (!newOperatorEmail || !newUserName || !data?.startTime || !data?.endTime || !collegeName || !collegeId) {
      toast.error("All fields are required");
      return;
    }
    await AdminService.createOperator(params.examId, {

      emailId: newOperatorEmail,
      userName: newUserName,
      accessStartTime: data.startTime,
      accessEndTime: data.endTime,
      examId: params.examId,
      collegeName: collegeName,
      collegId: collegeId,
      // stream: stream
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Opertro created successfully");
          getAllOperators();
          setShowCreteOperator(false);

          setNewOperatorEmail("");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Unable to creaet Opertaor");
      });
  };
  const deleteShift = async () => {
    await AdminService.deleteShift(params.examId, showDeleteShift)
      .then((res) => {
        if (res.status == 200) {
          toast.success("Shift deleted successfully");
          getAllExamById();
          setShowDeleteModal(undefined);
        }
      })
      .catch((e) => {
        toast.error("Unable to delete shift");
        console.error(e);
      });
  };

  const handleToggleExamOffline = async () => {
    await AdminService.toggleExamOffline(params.examId)
      .then((res) => {
        if (res.status === 200) {
          // setToggleExamOffline(true);
          toast.success("Success");
          getAllExamById();
        }
      })
      .catch((err) => {
        toast.error(err.response.data);
        setToggleExamOffline(false);
      });
  };

  const handleToggleShiftIsBiometricAllowed = async (shiftId: any) => {
    await ExamService.toggleShiftIsBiometricAllowed(params.examId, shiftId)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Shift biometric allowed toggled successfully");
          getAllExamById();
        }
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  useEffect(() => {
    getAllExamById();
    getAllEnums();
    getExamSetting();
    getAllClients();
    getAllOperators();
  }, []);

  return (
    <>
      <Card className="bio-card mt-4">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between">
            <h6 className="text-muted fw-bold">Exam: {exam && exam.name}</h6>
            <Form.Group className="d-flex align-items-center">
              <Form.Label className="fw-bold text-muted">Offline</Form.Label>
              <Form.Switch
                className="mb-2 ms-3"
                checked={toggleExamOffline}
                onClick={handleToggleExamOffline}
              />
            </Form.Group>
          </div>
          <hr className="text-muted" />
          <Row>
            <Col md={3}>
              <div className="mt-3">
                <div className="d-flex justify-content-between">
                  <p className="fw-bold xcn-text-14">Auth Settings</p>
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    className="text-muted ms-1 mt-1 xcn-text-14 xcn-link-pointer"
                    onClick={() => {
                      setShowEditModal(true);
                    }}
                  />
                </div>
                <div>
                  <Table striped hover className="xcn-text-12">
                    <thead>
                      <tr>
                        <th>
                          <span className="fw-bold text-muted">Auth Type</span>
                        </th>

                        <th>
                          <span className="fw-bold text-muted">Allowed</span>
                        </th>

                        <th>
                          <span className="fw-bold text-muted">Required</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {enumsData && enumsData.length > 0
                        ? enumsData.map((data: any) => {
                          const enum_val = examSetting?.find(
                            (setting: any) => setting.method == data
                          );
                          return (
                            <tr>
                              <td>
                                <span className="fw-bold text-capitalize">
                                  {data === "fingerprint"
                                    ? "Right Fingerprint"
                                    : data === "fingerprint2"
                                      ? "Left Fingerprint"
                                      : data}
                                </span>
                              </td>
                              <td>
                                {enum_val && enum_val.allowed ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    color="green"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    color="red"
                                  />
                                )}
                              </td>
                              <td>
                                {enum_val && enum_val.forceRequired ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    color="green"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    color="red"
                                  />
                                )}
                              </td>
                            </tr>
                          );
                        })
                        : "No Data"}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
            <Col md={9}>
              <div
                style={{
                  width: "100%",
                  minHeight: 500,
                  paddingLeft: "30px",
                  borderLeft: "1px solid #cccccc",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      marginTop: "20px",
                    }}
                  >
                    Shifts
                  </p>
                  <Button
                    variant="outline-primary"
                    className="fw-bold"
                    size="sm"
                    onClick={() => {
                      setShowShiftModal(true);
                    }}
                  >
                    Add Shifts
                  </Button>
                </div>

                <div>
                  <div>
                    <Table striped hover className="xcn-text-12">
                      <thead>
                        <tr>
                          <th>
                            <span className="fw-bold">Shift Name</span>
                          </th>
                          <th>
                            <span className="fw-bold">Status</span>
                          </th>
                          <th>
                            <span className="fw-bold">Biometric Allowed</span>
                          </th>
                          <th>
                            <span className="fw-bold">Start time</span>
                          </th>

                          <th>
                            <span className="fw-bold">End time</span>
                          </th>
                          <th>
                            <span className="fw-bold">
                              Biometric Start time
                            </span>
                          </th>
                          <th>
                            <span className="fw-bold">Biometric End time</span>
                          </th>
                          <th>
                            <span className="fw-bold">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {exam && exam.shifts && exam.shifts.length > 0
                          ? exam.shifts.map((shift: any) => {
                            return (
                              <>
                                <tr>
                                  <td className="xcn-text-10 fw-bold text-primary">
                                    {shift && shift.shiftName}
                                  </td>
                                  <td className="xcn-text-10 fw-bold text-primary">
                                    {shift && shift.isLive ? (
                                      <span className="text-success">
                                        Live
                                      </span>
                                    ) : (
                                      <span className="text-danger">
                                        Not-live
                                      </span>
                                    )}
                                  </td>
                                  <td className="xcn-text-10 fw-bold text-primary">
                                    <Form.Switch
                                      checked={
                                        shift && shift.isBiometricAllowed
                                      }
                                      onChange={(e) =>
                                        handleToggleShiftIsBiometricAllowed(
                                          shift._id
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="xcn-text-10 fw-bold text-secondary">
                                    {formatDate(shift && shift.startTime)}
                                  </td>
                                  <td className="xcn-text-10 fw-bold text-secondary">
                                    {formatDate(shift && shift.endTime)}
                                  </td>
                                  <td className="xcn-text-10 fw-bold text-secondary">
                                    {formatDate(
                                      shift && shift.biometricStartTime
                                    )}
                                  </td>
                                  <td className="xcn-text-10 fw-bold text-secondary">
                                    {formatDate(
                                      shift && shift.biometriEndTime
                                    )}
                                  </td>
                                  <td>
                                    {/* <Button variant='primary' className="xcn-text-12" size="sm" onClick={() => { navigate('/dashboard/upload/' + exam._id + "/" + (shift._id)) }} >
                                                                        <FontAwesomeIcon icon={faUpload} />
                                                                    </Button>
                                                                    <Button variant='danger' className="xcn-text-12 ms-2" size="sm" onClick={() => { setShowDeleteModal(shift._id) }} >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </Button> */}
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        as={CustomToggle}
                                        id="dropdown-custom-components"
                                      >
                                        <FontAwesomeIcon
                                          icon={faEllipsisVertical}
                                        />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          onClick={() => setEditShift(shift)}
                                        >
                                          <FontAwesomeIcon
                                            icon={faPenToSquare}
                                            className="text-primary me-2"
                                          />
                                          <span className="">Edit</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() => {
                                            navigate(
                                              "/dashboard/upload/" +
                                              exam._id +
                                              "/" +
                                              shift._id
                                            );
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faUpload}
                                            className="text-primary me-2"
                                          />
                                          <span className="">
                                            Upload Data
                                          </span>
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item
                                          onClick={() => {
                                            setShowDeleteModal(shift._id);
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faTrash}
                                            className="text-danger me-2"
                                          />
                                          <span className="text-danger">
                                            Delete
                                          </span>
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                          : "No table data"}
                      </tbody>
                    </Table>
                  </div>
                </div>
                <hr className="text-muted" />
                <Row>
                  <Col md={12}>
                    <div
                      style={{
                        borderRight: "1px solid #cccccc",
                        paddingRight: "20px",
                        minHeight: 200,
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <p
                          style={{ fontSize: "18px", fontWeight: "bold" }}
                          className="mt-2"
                        >
                          Clients
                        </p>
                        <Button
                          variant="outline-primary"
                          className="fw-bold"
                          size="sm"
                          onClick={() => setShowCreateClient(true)}
                        >
                          Create Client
                        </Button>
                      </div>
                      <div>
                        <ClientTable
                          clients={clients}
                          examId={params.examId}
                          reload={getAllClients}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div
                      style={{
                        borderRight: "1px solid #cccccc",
                        paddingRight: "20px",
                        minHeight: 200,
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <p
                          style={{ fontSize: "18px", fontWeight: "bold" }}
                          className="mt-2"
                        >
                          Re-Verification Operator
                        </p>
                        <Button
                          variant="outline-primary"
                          className="fw-bold"
                          size="sm"
                          onClick={() => setShowCreteOperator(true)}
                        >
                          create-operator
                        </Button>
                      </div>
                      <div>
                        <OperatorTable
                          operators={operators}
                          examId={params.examId}
                          reload={getAllOperators}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="mt-3 border-top pt-3">
            <Col>
              <ReverificationDetails examId={params?.examId} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <EditSettingModel
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        enumsData={enumsData}
        settings={examSetting}
        handleValue={handleCheckedValue}
        handleSubmission={updateSetting}
      />
      <ShiftModal
        params={params.examId}
        show={showShiftModal}
        handleClose={() => setShowShiftModal(false)}
        reload={getAllExamById}
      />
      <ConfirmModal
        titleText={"Confirm Shift Delete"}
        bodyText={"Are you sure you want to delete this shift?"}
        show={showDeleteShift ? true : false}
        onHide={() => setShowDeleteModal(undefined)}
        button={[
          {
            label: (
              <>
                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
              </>
            ),
            action: () => setShowDeleteModal(undefined),
            variant: "secondary",
          },
          {
            label: (
              <>
                <FontAwesomeIcon icon={faTrash} /> Delete
              </>
            ),
            action: deleteShift,
            variant: "danger",
          },
        ]}
      />
      <ConfirmModal
        titleText={"Create Client Modal"}
        bodyText={
          <>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Client Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter client email"
                value={newClientEmail}
                onChange={(e: any) => setNewClientEmail(e.target.value)}
              />
            </Form.Group>
          </>
        }
        show={showCreateClient}
        onHide={() => setShowCreateClient(false)}
        button={[
          {
            label: (
              <>
                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
              </>
            ),
            action: () => setShowCreateClient(false),
            variant: "secondary",
          },
          {
            label: (
              <>
                <FontAwesomeIcon icon={faCheck} /> Create
              </>
            ),
            action: handleCreateClient,
            variant: "success",
          },
        ]}
      />

      <ConfirmModal
        titleText={"Create operator modal"}
        size="lg"
        bodyText={
          <>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <label className="fw-bold xcn-text-12 text-secondary">
                Operator Username
              </label>
              <Form.Control
                type="userName"
                value={newUserName}
                onChange={(e: any) => setnewUserName(e.target.value)}
              />
            </Form.Group>


            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <label className="fw-bold xcn-text-12 text-secondary">
                Operator Email
              </label>
              <Form.Control
                type="email"
                value={newOperatorEmail}
                onChange={(e: any) => setNewOperatorEmail(e.target.value)}

              />

            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <label className="fw-bold xcn-text-12 text-secondary">
                College Name
              </label>
              <Form.Control
                type="text"
                value={collegeName}
                onChange={(e: any) => setCollegeName(e.target.value)}

              />
            </Form.Group>

            <Row>
              <Col>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <label className="fw-bold xcn-text-12 text-secondary">
                    College ID
                  </label>
                  <Form.Control
                    type="text"
                    value={collegeId}
                    onChange={(e: any) => setCollegeId(e.target.value)}

                  />

                </Form.Group>
              </Col>
            </Row>






            <Row className="mt-2">
              <Col md>
                <label className="fw-bold xcn-text-12 text-secondary">
                  Start Time
                </label>
                <DatePicker
                  dateFormat="yyyy/MM/dd h:mm aa"
                  showTimeSelect
                  selected={moment(data?.startTime).toDate()}
                  name="startTime"
                  onChange={(e) => {
                    handleChangeData({
                      target: { name: "startTime", value: e },
                    });
                  }}
                  className="form-control xcn-text-12"
                  minDate={new Date()}
                />
              </Col>
              <Col md>
                <label className="fw-bold xcn-text-12 text-secondary">
                  End Time
                </label>
                <DatePicker
                  dateFormat="yyyy/MM/dd h:mm aa"
                  showTimeSelect
                  name="endTime"
                  selected={moment(data?.endTime).toDate()}
                  onChange={(e) => {
                    handleChangeData({
                      target: { name: "endTime", value: e },
                    });
                  }}
                  className="form-control xcn-text-12"
                  minDate={new Date()}
                />
              </Col>
            </Row>
          </>
        }
        show={showCreateOperator}
        onHide={() => setShowCreteOperator(false)}
        button={[
          {
            label: (
              <>
                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
              </>
            ),
            action: () => setShowCreteOperator(false),
            variant: "secondary",
          },
          {
            label: (
              <>
                <FontAwesomeIcon icon={faCheck} /> Create
              </>
            ),
            action: handleCreateOperator,
            variant: "success",
          },
        ]}
      />

      <EditShiftModal
        show={editShift && editShift?._id}
        handleClose={() => setEditShift(null)}
        shift={editShift}
        reload={getAllExamById}
      />
    </>
  );
};

export default ExamById;
